import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { InitialSetupService } from './initial-setup.service';

@Injectable({
    providedIn: 'root'
})
export class SetupGuard implements CanActivate, CanActivateChild {

    constructor(
        private setupService: InitialSetupService,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return this.evaluateState(state.url);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return this.evaluateState(state.url);
    }

    private async evaluateState(url: string): Promise<boolean | UrlTree> {
        try {
            const status = await this.setupService.fetchStatus();
            const isSetupRoute = url.startsWith('/setup');

            if (!status.isConfigured && !isSetupRoute) {
                return this.router.createUrlTree(['/setup']);
            }

            if (status.isConfigured && isSetupRoute) {
                return this.router.createUrlTree(['/auth']);
            }
        } catch (error) {
            console.error('Unable to resolve initial setup status', error);
            // Allow navigation so the app can still load; user will see API error.
        }

        return true;
    }
}
